// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./fonts/Poppins-Regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./fonts/Poppins-Medium.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./fonts/Poppins-SemiBold.woff", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "popreg";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("woff");
  font-display: swap;
}
@font-face {
  font-family: "popmed";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff");
  font-display: swap;
}
@font-face {
  font-family: "popsemi";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff");
  font-display: swap;
}
:root {
  --main-color: #994f0e;
}

input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
input:-webkit-autofill:active {
  transition: background-color 5000s ease-in-out 0s;
  -webkit-transition: background-color 5000s ease-in-out 0s;
  box-shadow: 0 0 0px 1000px transparent inset;
  -webkit-text-fill-color: #000000 !important;
}

.flex {
  display: flex;
  align-items: center;
  justify-content: center;
}

.flexb {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.flexc {
  display: flex;
  flex-direction: column;
}

.tx {
  line-height: 1.7;
  font-size: max(14px, 0.9vw);
}

h1,
h2,
h3,
h5,
h6 {
  font-family: Arial, Helvetica, sans-serif;
  font-weight: 500;
}

*,
*::after,
*::before {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  text-decoration: none;
  list-style: none;
  outline: none;
}

body {
  width: 100%;
  height: 100%;
  font-family: "popreg";
}
body::-webkit-scrollbar {
  width: 10px;
}
@media (max-width: 1475px) {
  body::-webkit-scrollbar {
    width: 9px;
  }
}
body::-webkit-scrollbar-track {
  background: #e2e2e2;
  border-radius: 1px;
}
body::-webkit-scrollbar-thumb {
  background: linear-gradient(to bottom, #b86019, #522501);
  border-radius: 5px;
}

@keyframes pulse-blue {
  0% {
    box-shadow: 0 0 0 0 rgba(233, 97, 7, 0.5);
  }
  70% {
    box-shadow: 0 0 0 max(15px, 1vw) rgba(170, 85, 5, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(90, 49, 2, 0);
  }
}
@keyframes hvr-icon-drop {
  0% {
    opacity: 0;
  }
  50% {
    opacity: 0;
    transform: translateY(-100%);
  }
  51%, 100% {
    opacity: 1;
  }
}
button {
  cursor: pointer;
  outline: none;
}
@keyframes hvr-wobble-to-top-right {
  16.65% {
    transform: translate(8px, -8px);
  }
  33.3% {
    transform: translate(-6px, 6px);
  }
  49.95% {
    transform: translate(4px, -4px);
  }
  66.6% {
    transform: translate(-2px, 2px);
  }
  83.25% {
    transform: translate(1px, -1px);
  }
  100% {
    transform: translate(0, 0);
  }
}
@keyframes hvr-icon-buzz-out {
  10% {
    transform: translateX(3px) rotate(2deg);
  }
  20% {
    transform: translateX(-3px) rotate(-2deg);
  }
  30% {
    transform: translateX(3px) rotate(2deg);
  }
  40% {
    transform: translateX(-3px) rotate(-2deg);
  }
  50% {
    transform: translateX(2px) rotate(1deg);
  }
  60% {
    transform: translateX(-2px) rotate(-1deg);
  }
  70% {
    transform: translateX(2px) rotate(1deg);
  }
  80% {
    transform: translateX(-2px) rotate(-1deg);
  }
  90% {
    transform: translateX(1px) rotate(0);
  }
  100% {
    transform: translateX(-1px) rotate(0);
  }
}
@keyframes hvr-icon-drop {
  0% {
    opacity: 0;
  }
  50% {
    opacity: 0;
    transform: translateY(-100%);
  }
  51%, 100% {
    opacity: 1;
  }
}
.mn-btn {
  width: max(100px, 6.6vw);
  height: max(40px, 2.5vw);
  border-radius: 5px;
  background: var(--main-color);
  color: #fff;
  font-size: max(13px, 0.8vw);
  font-family: "popmed";
  display: flex;
  justify-content: center;
  align-items: center;
}
.mn-btn:hover {
  animation: pulse-blue 0.8s ease-in-out;
}`, "",{"version":3,"sources":["webpack://./src/App.scss"],"names":[],"mappings":"AAAA;EACE,qBAAA;EACA,2DAAA;EACA,kBAAA;AACF;AACA;EACE,qBAAA;EACA,2DAAA;EACA,kBAAA;AACF;AACA;EACE,sBAAA;EACA,2DAAA;EACA,kBAAA;AACF;AAEA;EACE,qBAAA;AAAF;;AAGA;;;;EAIE,iDAAA;EACA,yDAAA;EAEA,4CAAA;EACA,2CAAA;AAAF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;AACF;;AACA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;AAEF;;AAAA;EACE,aAAA;EACA,sBAAA;AAGF;;AADA;EACE,gBAAA;EACA,2BAAA;AAIF;;AAFA;;;;;EAKE,yCAAA;EACA,gBAAA;AAKF;;AAFA;;;EAGE,SAAA;EACA,UAAA;EACA,sBAAA;EACA,qBAAA;EACA,gBAAA;EACA,aAAA;AAKF;;AAFA;EACE,WAAA;EACA,YAAA;EACA,qBAAA;AAKF;AAJE;EACE,WAAA;AAMJ;AALI;EAFF;IAGI,UAAA;EAQJ;AACF;AALE;EACE,mBAAA;EACA,kBAAA;AAOJ;AALE;EACE,wDAAA;EACA,kBAAA;AAOJ;;AAHA;EACE;IACE,yCAAA;EAMF;EAJA;IACE,oDAAA;EAMF;EAJA;IACE,sCAAA;EAMF;AACF;AAsBA;EACE;IACE,UAAA;EAIF;EAFA;IACE,UAAA;IAEA,4BAAA;EAIF;EAFA;IAEE,UAAA;EAGF;AACF;AAAA;EACE,eAAA;EACA,aAAA;AAEF;AA2BA;EACE;IAEE,+BAAA;EAEF;EAAA;IAEE,+BAAA;EAEF;EAAA;IAEE,+BAAA;EAEF;EAAA;IAEE,+BAAA;EAEF;EAAA;IAEE,+BAAA;EAEF;EAAA;IAEE,0BAAA;EAEF;AACF;AA2CA;EACE;IAEE,uCAAA;EACF;EACA;IAEE,yCAAA;EACF;EACA;IAEE,uCAAA;EACF;EACA;IAEE,yCAAA;EACF;EACA;IAEE,uCAAA;EACF;EACA;IAEE,yCAAA;EACF;EACA;IAEE,uCAAA;EACF;EACA;IAEE,yCAAA;EACF;EACA;IAEE,oCAAA;EACF;EACA;IAEE,qCAAA;EACF;AACF;AAgBA;EACE;IACE,UAAA;EADF;EAGA;IACE,UAAA;IAEA,4BAAA;EADF;EAGA;IAEE,UAAA;EAFF;AACF;AAMA;EACI,wBAAA;EACA,wBAAA;EACA,kBAAA;EACA,6BAAA;EACA,WAAA;EACA,2BAAA;EACA,qBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAJJ;AAKI;EACE,sCAAA;AAHN","sourcesContent":["@font-face {\r\n  font-family: \"popreg\";\r\n  src: url(\"./fonts/Poppins-Regular.woff\") format(\"woff\");\r\n  font-display: swap;\r\n}\r\n@font-face {\r\n  font-family: \"popmed\";\r\n  src: url(\"./fonts/Poppins-Medium.woff\") format(\"woff\");\r\n  font-display: swap;\r\n}\r\n@font-face {\r\n  font-family: \"popsemi\";\r\n  src: url(\"./fonts/Poppins-SemiBold.woff\") format(\"woff\");\r\n  font-display: swap;\r\n}\r\n\r\n:root {\r\n  --main-color: #994f0e;\r\n}\r\n\r\ninput:-webkit-autofill,\r\ninput:-webkit-autofill:hover,\r\ninput:-webkit-autofill:focus,\r\ninput:-webkit-autofill:active {\r\n  transition: background-color 5000s ease-in-out 0s;\r\n  -webkit-transition: background-color 5000s ease-in-out 0s;\r\n  -webkit-box-shadow: 0 0 0px 1000px transparent inset;\r\n  box-shadow: 0 0 0px 1000px transparent inset;\r\n  -webkit-text-fill-color: #000000 !important;\r\n}\r\n.flex {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n.flexb {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n}\r\n.flexc {\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n.tx {\r\n  line-height: 1.7;\r\n  font-size: max(14px, 0.9vw);\r\n}\r\nh1,\r\nh2,\r\nh3,\r\nh5,\r\nh6 {\r\n  font-family: Arial, Helvetica, sans-serif;\r\n  font-weight: 500;\r\n}\r\n\r\n*,\r\n*::after,\r\n*::before {\r\n  margin: 0;\r\n  padding: 0;\r\n  box-sizing: border-box;\r\n  text-decoration: none;\r\n  list-style: none;\r\n  outline: none;\r\n}\r\n\r\nbody {\r\n  width: 100%;\r\n  height: 100%;\r\n  font-family: \"popreg\";\r\n  &::-webkit-scrollbar {\r\n    width: 10px;\r\n    @media (max-width: 1475px) {\r\n      width: 9px;\r\n    }\r\n  }\r\n\r\n  &::-webkit-scrollbar-track {\r\n    background: #e2e2e2;\r\n    border-radius: 1px;\r\n  }\r\n  &::-webkit-scrollbar-thumb {\r\n    background: linear-gradient(to bottom, #b86019, #522501);\r\n    border-radius: 5px;\r\n  }\r\n}\r\n\r\n@keyframes pulse-blue {\r\n  0% {\r\n    box-shadow: 0 0 0 0 rgba(#e96107, 0.5);\r\n  }\r\n  70% {\r\n    box-shadow: 0 0 0 max(15px, 1vw) rgba(170, 85, 5, 0);\r\n  }\r\n  100% {\r\n    box-shadow: 0 0 0 0 rgba(90, 49, 2, 0);\r\n  }\r\n}\r\n@-webkit-keyframes pulse-blue {\r\n  0% {\r\n    box-shadow: 0 0 0 0 rgba(#e96107, 0.5);\r\n  }\r\n  70% {\r\n    box-shadow: 0 0 0 max(15px, 1vw) rgba(170, 85, 5, 0);\r\n  }\r\n  100% {\r\n    box-shadow: 0 0 0 0 rgba(90, 49, 2, 0);\r\n  }\r\n}\r\n\r\n@-webkit-keyframes hvr-icon-drop {\r\n  0% {\r\n    opacity: 0;\r\n  }\r\n  50% {\r\n    opacity: 0;\r\n    -webkit-transform: translateY(-100%);\r\n    transform: translateY(-100%);\r\n  }\r\n  51%,\r\n  100% {\r\n    opacity: 1;\r\n  }\r\n}\r\n@keyframes hvr-icon-drop {\r\n  0% {\r\n    opacity: 0;\r\n  }\r\n  50% {\r\n    opacity: 0;\r\n    -webkit-transform: translateY(-100%);\r\n    transform: translateY(-100%);\r\n  }\r\n  51%,\r\n  100% {\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\nbutton {\r\n  cursor: pointer;\r\n  outline: none;\r\n}\r\n\r\n@-webkit-keyframes hvr-wobble-to-top-right {\r\n  16.65% {\r\n    -webkit-transform: translate(8px, -8px);\r\n    transform: translate(8px, -8px);\r\n  }\r\n  33.3% {\r\n    -webkit-transform: translate(-6px, 6px);\r\n    transform: translate(-6px, 6px);\r\n  }\r\n  49.95% {\r\n    -webkit-transform: translate(4px, -4px);\r\n    transform: translate(4px, -4px);\r\n  }\r\n  66.6% {\r\n    -webkit-transform: translate(-2px, 2px);\r\n    transform: translate(-2px, 2px);\r\n  }\r\n  83.25% {\r\n    -webkit-transform: translate(1px, -1px);\r\n    transform: translate(1px, -1px);\r\n  }\r\n  100% {\r\n    -webkit-transform: translate(0, 0);\r\n    transform: translate(0, 0);\r\n  }\r\n}\r\n@keyframes hvr-wobble-to-top-right {\r\n  16.65% {\r\n    -webkit-transform: translate(8px, -8px);\r\n    transform: translate(8px, -8px);\r\n  }\r\n  33.3% {\r\n    -webkit-transform: translate(-6px, 6px);\r\n    transform: translate(-6px, 6px);\r\n  }\r\n  49.95% {\r\n    -webkit-transform: translate(4px, -4px);\r\n    transform: translate(4px, -4px);\r\n  }\r\n  66.6% {\r\n    -webkit-transform: translate(-2px, 2px);\r\n    transform: translate(-2px, 2px);\r\n  }\r\n  83.25% {\r\n    -webkit-transform: translate(1px, -1px);\r\n    transform: translate(1px, -1px);\r\n  }\r\n  100% {\r\n    -webkit-transform: translate(0, 0);\r\n    transform: translate(0, 0);\r\n  }\r\n}\r\n\r\n@-webkit-keyframes hvr-icon-buzz-out {\r\n  10% {\r\n    -webkit-transform: translateX(3px) rotate(2deg);\r\n    transform: translateX(3px) rotate(2deg);\r\n  }\r\n  20% {\r\n    -webkit-transform: translateX(-3px) rotate(-2deg);\r\n    transform: translateX(-3px) rotate(-2deg);\r\n  }\r\n  30% {\r\n    -webkit-transform: translateX(3px) rotate(2deg);\r\n    transform: translateX(3px) rotate(2deg);\r\n  }\r\n  40% {\r\n    -webkit-transform: translateX(-3px) rotate(-2deg);\r\n    transform: translateX(-3px) rotate(-2deg);\r\n  }\r\n  50% {\r\n    -webkit-transform: translateX(2px) rotate(1deg);\r\n    transform: translateX(2px) rotate(1deg);\r\n  }\r\n  60% {\r\n    -webkit-transform: translateX(-2px) rotate(-1deg);\r\n    transform: translateX(-2px) rotate(-1deg);\r\n  }\r\n  70% {\r\n    -webkit-transform: translateX(2px) rotate(1deg);\r\n    transform: translateX(2px) rotate(1deg);\r\n  }\r\n  80% {\r\n    -webkit-transform: translateX(-2px) rotate(-1deg);\r\n    transform: translateX(-2px) rotate(-1deg);\r\n  }\r\n  90% {\r\n    -webkit-transform: translateX(1px) rotate(0);\r\n    transform: translateX(1px) rotate(0);\r\n  }\r\n  100% {\r\n    -webkit-transform: translateX(-1px) rotate(0);\r\n    transform: translateX(-1px) rotate(0);\r\n  }\r\n}\r\n@keyframes hvr-icon-buzz-out {\r\n  10% {\r\n    -webkit-transform: translateX(3px) rotate(2deg);\r\n    transform: translateX(3px) rotate(2deg);\r\n  }\r\n  20% {\r\n    -webkit-transform: translateX(-3px) rotate(-2deg);\r\n    transform: translateX(-3px) rotate(-2deg);\r\n  }\r\n  30% {\r\n    -webkit-transform: translateX(3px) rotate(2deg);\r\n    transform: translateX(3px) rotate(2deg);\r\n  }\r\n  40% {\r\n    -webkit-transform: translateX(-3px) rotate(-2deg);\r\n    transform: translateX(-3px) rotate(-2deg);\r\n  }\r\n  50% {\r\n    -webkit-transform: translateX(2px) rotate(1deg);\r\n    transform: translateX(2px) rotate(1deg);\r\n  }\r\n  60% {\r\n    -webkit-transform: translateX(-2px) rotate(-1deg);\r\n    transform: translateX(-2px) rotate(-1deg);\r\n  }\r\n  70% {\r\n    -webkit-transform: translateX(2px) rotate(1deg);\r\n    transform: translateX(2px) rotate(1deg);\r\n  }\r\n  80% {\r\n    -webkit-transform: translateX(-2px) rotate(-1deg);\r\n    transform: translateX(-2px) rotate(-1deg);\r\n  }\r\n  90% {\r\n    -webkit-transform: translateX(1px) rotate(0);\r\n    transform: translateX(1px) rotate(0);\r\n  }\r\n  100% {\r\n    -webkit-transform: translateX(-1px) rotate(0);\r\n    transform: translateX(-1px) rotate(0);\r\n  }\r\n}\r\n\r\n@-webkit-keyframes hvr-icon-drop {\r\n  0% {\r\n    opacity: 0;\r\n  }\r\n  50% {\r\n    opacity: 0;\r\n    -webkit-transform: translateY(-100%);\r\n    transform: translateY(-100%);\r\n  }\r\n  51%,\r\n  100% {\r\n    opacity: 1;\r\n  }\r\n}\r\n@keyframes hvr-icon-drop {\r\n  0% {\r\n    opacity: 0;\r\n  }\r\n  50% {\r\n    opacity: 0;\r\n    -webkit-transform: translateY(-100%);\r\n    transform: translateY(-100%);\r\n  }\r\n  51%,\r\n  100% {\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\n\r\n.mn-btn{\r\n    width: max(100px, 6.6vw);\r\n    height: max(40px, 2.5vw);\r\n    border-radius: 5px;\r\n    background: var(--main-color);\r\n    color: #fff;\r\n    font-size: max(13px, 0.8vw);\r\n    font-family: \"popmed\";\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    &:hover {\r\n      animation: pulse-blue 0.8s ease-in-out;\r\n    }\r\n\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
